import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss']
})
export class BottomSheetComponent {

  constructor(
    public router: Router,
    private _bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public info: any
  ) { }

  openLink(event: MouseEvent, route: string): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
    this.router.navigateByUrl(this.info?.pathRoute + route);
  }

  isActive(route: string): boolean {
    if (this.info?.type == 'projeto') {
      return this.router.routerState.snapshot.url.includes(route);
    } else if (this.info?.type == 'agregador') {
      return this.router.routerState.snapshot.url.replace('/projetos/agregador/', '').includes(route);
    }
    let url = this.router.routerState.snapshot.url;
    return url == route;
  }
}

